export const localStorageData = {
  USER: "user",
  SETTINGS: "settings",
  GLOBALES: "globales",
  AUTH_TOKENS: "authTokens",
  LAST_INFO: "lastInfo",
  CAJA_ID: "cajaID",
};

export const intervals = {
  SESSION_LISTENER: 10000,
};
